import React, { useEffect, useRef, useState, useCallback } from "react";
import { Col, Container, Row, Spinner } from "react-bootstrap";
import { getRandomNumberInRange, getUrl } from "../../../MIS/Global";
import axios from "axios";
import CategoryCard from "../Cards/CategoryCard";
import { useParams } from "react-router-dom";
import { FaBoxOpen } from "react-icons/fa";
import { useSelector } from "react-redux";
import { FaThLarge, FaTh} from 'react-icons/fa'; 
import PageHistory from "../../GlobalComponent/PageHistory";
import { decrypt, encrypt } from "../../../MIS/encryption";
const TbkProductPageScrollLoad = () => {
  // const { mpid=0,subid=0,searchQuery="",spname="" } = useParams();
  let { mpid=0,subid=0,searchQuery="",spname="" } = useParams();
  subid = decrypt(subid)
  const [lastId, setLastId] = useState(0);
  const [limit] = useState(getRandomNumberInRange(25, 40));
  const [subProducts, setSubProducts] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [hasMore, setHasMore] = useState(true);  
  const [isSingleColumn, setIsSingleColumn] = useState(true);
  const [subProductName, setSubProductName] = useState("");
  const observer = useRef();

  const { userWishList } = useSelector((state) => state.user);

  const toggleColumn = () => {
    setIsSingleColumn((prev) => !prev);
  };

  const apiClient = axios.create({
    baseURL: getUrl(),
    headers: { "Content-Type": "application/json" },
  });

  const handleWishlistData = (data) => {
    if (!data || data.length === 0) return;
    let wishlistIds = new Set(userWishList.map(item => item.pid));
    const updatedProducts = data.map(product => ({
      ...product,
      isWishlist: wishlistIds.has(product.id),
    }));
    setSubProducts(updatedProducts);
  };

  const fetchData = useCallback(async () => {
    if (isLoading || !hasMore) return;
    setIsLoading(true);
    let data = { limit, subid,mpid,searchQuery,id: lastId, action: "getProducts" };
         
    if (lastId <= 0) {    
      data = { limit, subid,mpid,searchQuery, action: "getProducts" };
    }
    if(mpid<=0){delete data.mpid}
    if(searchQuery==""){delete data.searchQuery}
    if(subid<=0){delete data.subid}
        
    try {
      const res = await apiClient.post("tbk-product/", data);
      const newItems = res?.data?.data || [];      
      if (newItems.length > 0) {        
        setSubProductName(res?.data?.data?.[0]?.subpname)
        setSubProducts((prevItems) => {
          const uniqueItems = newItems.filter(
            (item) => !prevItems.some((prev) => prev.id === item.id)
          );
          return [...prevItems, ...uniqueItems];
        });
        setLastId(newItems[newItems.length - 1].id);
      } else {
        setIsLoading(false);
        setHasMore(false);
      }
    } catch (error) {
      // console.error("Error fetching data:", error);
    } finally {
      setIsLoading(false);
      
    }
  }, [lastId, limit, subid, isLoading, hasMore]);


  useEffect(() => {
     fetchData();    
  }, [fetchData]);
   

  useEffect(() => {
    if (subProducts.length > 0) {
      handleWishlistData(subProducts);
    }
  }, [userWishList]);

  // ✅ Observer using ref callback
  const lastItemRef = useCallback(
    (node) => {
      if (isLoading) return;
      if (observer.current) observer.current.disconnect();

      observer.current = new IntersectionObserver(
        (entries) => {
          if (entries[0].isIntersecting && hasMore) {
            fetchData();
          }
        },
        { threshold: 1.0 }
      );

      if (node) observer.current.observe(node);
    },
    [isLoading, hasMore, fetchData]
  );
  const breadcrumbData = [
    { label: subProductName, path: "/category" },
    { label: "Products", path: "/products" },    
  ];
  return (
    <Container className="h-full mb-2">
      <Row  className="pt-1"
        style={{
          position: "sticky",
          top: 0,
          zIndex: 10,       
        }}       
       >
        <Col xs={8} md={12}>
          <PageHistory history={breadcrumbData} />
          {/* <h6>Showing all ({subProducts.length}) results</h6> */}
        </Col>
         <Col xs={4}>
        <div
          className="d-sm-none mb-3 d-flex justify-content-end align-content-center pt-1"
          onClick={toggleColumn}
          style={{ textAlign: 'right', cursor: 'pointer' }}
        >
        {isSingleColumn ? <FaThLarge size={24} /> : <FaTh size={24} />}
       
      </div>
        </Col>
      </Row>
      <div style={{ overflowY: "auto", height: "calc(100vh - 80px)", paddingTop: "10px" }}>
      
      {subProducts.length === 0 && !isLoading && !hasMore && (
        <Row className="d-flex justify-content-center align-items-center text-center" style={{ height: "50vh" }}>
          <Col xs={12}>
            <FaBoxOpen size={50} color="#ff6b6b" />
            <h4 style={{ color: "#555", marginTop: "10px" }}>No Products Found</h4>
            <p style={{ color: "#777" }}>Try a different category or check back later.</p>
          </Col>
        </Row>
      )}

      <Row className="d-flex justify-content-center align-items-center gx-1 gy-1 gx-md-3 gy-md-3">
        {subProducts.map((element, index) => {
          if (index === subProducts.length - 1) {
            return (
              <Col
                ref={lastItemRef}
                key={element.id}
                xs={isSingleColumn ? 12 : 6}
                sm={isSingleColumn ? 12 : 6}
                md={4}
                lg={4}
              >
                <CategoryCard
                  product={element}
                  path={`/tbkDetail/${encrypt(element?.id)}/${encrypt(element?.subid)}`}
                  wishlist={true}
                  price={true}
                  productDetail={true}
                />
              </Col>
            );
          } else {
            return (
              <Col key={element.id} 
                xs={isSingleColumn ? 12 : 6}
                sm={isSingleColumn ? 12 : 6} 
                md={4} lg={4}>
                <CategoryCard
                  product={element}
                  path={`/tbkDetail/${encrypt(element?.id)}/${encrypt(element?.subid)}`}
                  wishlist={true}
                  price={true}
                  productDetail={true}
                />
              </Col>
            );
          }
        })}

        {isLoading && hasMore && (
          <Col xs={12} className="d-flex justify-content-center align-items-center">
            <Spinner animation="border" variant="primary" />
          </Col>
        )}
        
      </Row>
      </div>
    </Container>
  );
};

export default TbkProductPageScrollLoad;
